import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const common: PartialTranslation["common"] = {
  /** Destructive-toast title used across surfaces. */
  error: "Lỗi",
  actions: {
    save: "Lưu",
    cancel: "Hủy",
    close: "Đóng",
    delete: "Xóa",
    edit: "Chỉnh sửa",
    create: "Tạo",
    add: "Thêm",
    remove: "Gỡ",
    update: "Cập nhật",
    confirm: "Xác nhận",
    back: "Quay lại",
    next: "Tiếp",
    previous: "Trước",
    finish: "Hoàn tất",
    submit: "Gửi",
    retry: "Thử lại",
    copy: "Sao chép",
    copied: "Đã sao chép",
    share: "Chia sẻ",
    download: "Tải xuống",
    upload: "Tải lên",
    search: "Tìm kiếm",
    clearSearch: "Xoá tìm kiếm",
    filter: "Lọc",
    clear: "Xóa",
    clearAll: "Xóa tất cả",
    selectAll: "Chọn tất cả",
    apply: "Áp dụng",
    reset: "Đặt lại",
    continue: "Tiếp tục",
    start: "Bắt đầu",
    pause: "Tạm dừng",
    resume: "Tiếp tục",
    skip: "Bỏ qua",
    done: "Xong",
    seeAll: "Xem tất cả",
    showMore: "Xem thêm",
    showLess: "Thu gọn",
    learnMore: "Tìm hiểu thêm",
    viewAll: "Xem tất cả",
    loading: "Đang tải…",
    saving: "Đang lưu…",
    send: "Gửi",
    signIn: "Đăng nhập",
    signUp: "Đăng ký",
    signOut: "Đăng xuất",
    /** Nhận phần thưởng đã sẵn sàng — cột mốc chuỗi, thử thách hoàn thành. */
    claim: "Nhận",
    today: "Hôm nay",
  },
  states: {
    loading: "Đang tải…",
    error: "Đã xảy ra lỗi",
    empty: "Chưa có gì ở đây",
    noResults: "Không tìm thấy kết quả",
    offline: "Bạn đang ngoại tuyến",
    errorRetry: "Không thành công. Hãy thử lại.",
    notFoundTitle: "Không tìm thấy trang",
    notFoundDescription: "Rất tiếc, chúng tôi không tìm thấy trang bạn đang tìm. Trang có thể đã được chuyển đi hoặc không tồn tại.",
    goBack: "Quay lại",
    backToHome: "Về trang chủ",
    pageLabel: "Trang 404",
  },
  mascot: {
    openLabel: "Mở trợ lý học tập hoặc từ điển",
  },
  labels: {
    loading: "Đang tải",
    optional: "không bắt buộc",
    required: "bắt buộc",
    words: "Từ",
    word: "Từ",
    topics: "Chủ đề",
    topic: "Chủ đề",
    questions: "Câu hỏi",
    question: "Câu hỏi",
    vocab: "Từ vựng",
    minutes: "phút",
    level: "Trình độ",
  },
  count: {
    // Vietnamese has no plural inflection: "1 từ" and "5 từ" are identical
    // apart from the numeral. i18next only needs `_other` for `vi`, so the
    // English `_one` key is intentionally absent here.
    word_other: "{{count}} từ",
    topic_other: "{{count}} chủ đề",
    question_other: "{{count}} câu hỏi",
    vocab_other: "{{count}} từ vựng",
    video_other: "{{count}} video",
    views_other: "{{count}} lượt xem",
    likes_other: "{{count}} lượt thích",
    comments_other: "{{count}} bình luận",
    item_other: "{{count}} mục",
  },
  time: {
    justNow: "vừa xong",
    today: "Hôm nay",
    yesterday: "Hôm qua",
    week_short: "tuần",
    day_short: "ngày",
  },
  errors: {
    generic: "Đã xảy ra lỗi. Vui lòng thử lại.",
    network: "Lỗi mạng. Hãy kiểm tra kết nối của bạn.",
    unauthorized: "Vui lòng đăng nhập để tiếp tục.",
    notFound: "Không tìm thấy nội dung này.",
    tryAgain: "Vui lòng thử lại.",
  },
  };
